/**
 * Mobile Browser Compatibility Script
 * Handles viewport and layout issues on real mobile devices
 */

// iOS Safari viewport height fix
function setMobileViewportHeight() {
  // Get the viewport height and multiply it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Update on resize (for orientation changes)
window.addEventListener('resize', setMobileViewportHeight);
window.addEventListener('orientationchange', () => {
  // Delay to ensure orientation change is complete
  setTimeout(setMobileViewportHeight, 100);
});

// Initial set
setMobileViewportHeight();

// Prevent zoom on input focus for iOS
function preventZoom() {
  const viewportMeta = document.querySelector('meta[name="viewport"]');
  if (viewportMeta) {
    const content = viewportMeta.getAttribute('content');
    if (!content.includes('maximum-scale=1')) {
      viewportMeta.setAttribute('content', content + ', maximum-scale=1');
    }
  }
}

// Handle keyboard appearance on mobile
function handleKeyboard() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  
  if (isIOS || isAndroid) {
    // Listen for focus on input elements
    document.addEventListener('focusin', function(e) {
      if (e.target.matches('input, textarea')) {
        // Small delay to ensure keyboard is shown
        setTimeout(() => {
          e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      }
    });
    
    // Listen for blur to reset viewport
    document.addEventListener('focusout', function(e) {
      if (e.target.matches('input, textarea')) {
        // Reset viewport height after keyboard closes
        setTimeout(setMobileViewportHeight, 300);
      }
    });
  }
}

// Enhanced touch handling
function improveTouchExperience() {
  // Improve tap responsiveness
  document.addEventListener('touchstart', function() {}, { passive: true });
  
  // Prevent accidental touch actions
  document.addEventListener('touchmove', function(e) {
    // Allow scrolling in scrollable containers
    let element = e.target;
    while (element && element !== document.body) {
      const style = window.getComputedStyle(element);
      if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
        return; // Allow scroll
      }
      element = element.parentElement;
    }
  }, { passive: true });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    preventZoom();
    handleKeyboard();
    improveTouchExperience();
  });
} else {
  preventZoom();
  handleKeyboard();
  improveTouchExperience();
}

// Export for use in React components if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    setMobileViewportHeight,
    preventZoom,
    handleKeyboard,
    improveTouchExperience
  };
}
